import Dialog from './dialog';
import Popup from './popup';
import { alert, confirm, show, hide, success, error, notice, warning, help } from './funcs';
import './styles/index.scss';
const ExpandedDialog = Dialog;
ExpandedDialog.show = show;
ExpandedDialog.hide = hide;
ExpandedDialog.alert = alert;
ExpandedDialog.success = success;
ExpandedDialog.error = error;
ExpandedDialog.notice = notice;
ExpandedDialog.warning = warning;
ExpandedDialog.help = help;
ExpandedDialog.confirm = confirm;
ExpandedDialog.Popup = Popup;
export default ExpandedDialog;
